<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app id="app">
    <div class="allover" v-if="showIdle">
      <v-container justify-center fill-height>
        <v-row justify="center" class="justify-center">
          <v-col cols="12" class="text-center">
            <span style="font-size: 18px;font-weight: bold;color:#FAFAFA" v-if="idleText" v-html="idleText">

            </span>
          </v-col>
          <v-col cols="12" class="justify-center">
            <center>
            <SelfBuildingSquareSpinner></SelfBuildingSquareSpinner>
            </center>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-snackbar
        v-model="snackbar"
        :top="true"
        :timeout="6000"
    >
      {{ snackbarText }}
      <v-btn
          color="bluetext"
          @click="snackbar = false"
      >
        Schliessen
      </v-btn>
    </v-snackbar>
    <v-snackbar
        v-model="uploadFeedbackVisible"
        bottom
        right
        :timeout="0"
        min-width="360"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-3" :color="uploadFeedbackColor">
          {{ uploadFeedbackIcon }}
        </v-icon>
        <div class="flex-grow-1">
          <div class="font-weight-medium">{{ uploadFeedbackTitle }}</div>
          <div class="caption">{{ uploadFeedbackText }}</div>
          <v-progress-linear
              v-if="uploadFeedbackState === 'uploading' || uploadFeedbackState === 'processing'"
              class="mt-2"
              color="light-blue"
              height="8"
              :value="uploadProgress"
              :indeterminate="uploadFeedbackState === 'processing'"
              striped
          ></v-progress-linear>
        </div>
        <v-btn text small @click="dismissUploadFeedback">OK</v-btn>
      </div>
    </v-snackbar>
    <router-view/>
  </v-app>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import {SelfBuildingSquareSpinner} from 'epic-spinners'

export default {
  name: 'App',
  components: {SelfBuildingSquareSpinner},
  data: () => ({
    isLogin: true,
    progress: 100,
    showIdle: false,
    snackbar: false,
    snackbarText: '',
    idleText: '',
    uploadFeedbackVisible: false,
    uploadFeedbackState: 'uploading',
    uploadProgress: 0,
    uploadErrorMessage: '',
    uploadDismissTimer: null,
    sessionHeartbeatTimer: null
  }),
  computed: {
    uploadFeedbackIcon() {
      if (this.uploadFeedbackState === 'success') return 'check_circle'
      if (this.uploadFeedbackState === 'error') return 'error'
      return this.uploadFeedbackState === 'processing' ? 'settings' : 'cloud_upload'
    },
    uploadFeedbackColor() {
      if (this.uploadFeedbackState === 'success') return 'green'
      if (this.uploadFeedbackState === 'error') return 'red'
      return 'light-blue'
    },
    uploadFeedbackTitle() {
      if (this.uploadFeedbackState === 'success') return 'Upload abgeschlossen'
      if (this.uploadFeedbackState === 'error') return 'Upload fehlgeschlagen'
      if (this.uploadFeedbackState === 'processing') return 'Datei wird verarbeitet'
      return 'Datei wird hochgeladen'
    },
    uploadFeedbackText() {
      if (this.uploadFeedbackState === 'success') return 'Die Datei wurde erfolgreich hochgeladen.'
      if (this.uploadFeedbackState === 'error') return this.uploadErrorMessage || 'Bitte erneut versuchen oder den Support kontaktieren.'
      if (this.uploadFeedbackState === 'processing') return 'Datei übertragen. Video wird bei Bedarf für den Player vorbereitet.'
      return this.uploadProgress + ' % übertragen'
    }
  },
  methods: {
    OnShowIdle(show) {
      if (show instanceof Object) {
        this.showIdle = show.show
        this.idleText = show.text
      } else {
        this.showIdle = show
      }
    },
    OnProgress(progress) {
      console.log('OnProgress', progress)
      this.dismissUploadFeedback(true)
      this.progress = Number(progress) || 0
      this.uploadProgress = Math.min(100, Math.max(0, this.progress))
      this.uploadFeedbackVisible = true

      if (this.uploadProgress >= 100) {
        this.uploadFeedbackState = 'processing'
      } else {
        this.uploadFeedbackState = 'uploading'
      }
    },
    OnUploadSuccess() {
      this.dismissUploadFeedback(true)
      this.uploadProgress = 100
      this.uploadFeedbackState = 'success'
      this.uploadFeedbackVisible = true
      this.uploadDismissTimer = setTimeout(() => {
        this.dismissUploadFeedback()
      }, 3000)
    },
    OnUploadError(message) {
      this.dismissUploadFeedback(true)
      this.uploadFeedbackState = 'error'
      this.uploadErrorMessage = typeof message === 'string' && message.trim()
        ? message
        : 'Bitte erneut versuchen oder den Support kontaktieren.'
      this.uploadFeedbackVisible = true
    },
    dismissUploadFeedback(keepVisible) {
      if (this.uploadDismissTimer) {
        clearTimeout(this.uploadDismissTimer)
        this.uploadDismissTimer = null
      }
      if (!keepVisible) {
        this.uploadFeedbackVisible = false
      }
    },
    refreshAuthenticatedSession() {
      var credentials = Vue.prototype.$api.getCredentials()
      if (!credentials || !credentials.authorized || document.visibilityState !== 'visible') return

      $.ajax({
        method: 'POST',
        url: Vue.prototype.$config.HOST + '/v1/user/loginv2/refresh',
        dataType: 'json'
      }).done((response) => {
        if (!response || !response.success || !response.user) return

        var refreshedCredentials = Object.assign({}, credentials, {
          authToken: response.user.authToken || credentials.authToken,
          data: Object.assign({}, credentials.data, response.user)
        })
        Vue.prototype.$api.setCredentials(refreshedCredentials)
        $.ajaxSetup({ headers: { 'X-Auth-Token': refreshedCredentials.authToken } })
      }).fail((error) => {
        // An invalid or expired session must use the established login route.
        // Temporary backend/network failures must not discard ongoing work.
        if (error && error.status === 401) Vue.prototype.$api.resetCredentials(this)
      })
    }
  },
  created() {
    Vue.prototype.$eventHub.$on('OnShowIdle', this.OnShowIdle)
    Vue.prototype.$eventHub.$on('OnProgress', this.OnProgress)
    Vue.prototype.$eventHub.$on('OnUploadSuccess', this.OnUploadSuccess)
    Vue.prototype.$eventHub.$on('OnUploadError', this.OnUploadError)

  },
  beforeDestroy() {
    this.dismissUploadFeedback(true)
    if (this.sessionHeartbeatTimer) clearInterval(this.sessionHeartbeatTimer)
  },
  destroyed() {
    Vue.prototype.$eventHub.$off('OnShowIdle', this.OnShowIdle)
    Vue.prototype.$eventHub.$off('OnProgress', this.OnProgress)
    Vue.prototype.$eventHub.$off('OnUploadSuccess', this.OnUploadSuccess)
    Vue.prototype.$eventHub.$off('OnUploadError', this.OnUploadError)
  },
  mounted() {
    window.addEventListener('resize', () => {
      Vue.prototype.$eventHub.$emit('resize');
    });
    // The server issues a short-lived session cookie. Renew it while the
    // classic portal is open, just like the Vue 3 Offer application does.
    this.sessionHeartbeatTimer = setInterval(() => this.refreshAuthenticatedSession(), 5 * 60 * 1000)
    this.refreshAuthenticatedSession()
  }
};
</script>
